import { FETCH_DATA, REMOVE_DATA, SET_HEADER_TITLE, SAVE_DATA } from "./types"

export const fetchData = payload => ({
    type:FETCH_DATA,
    payload
});

export const removeData = payload => ({
    type:REMOVE_DATA,
    payload
});

export const setHeaderTitle = payload => ({
	type: SET_HEADER_TITLE,
	payload
})

export const saveData = payload => ({
	type: SAVE_DATA,
	payload
})


// WEBPACK FOOTER //
// ./src/store/action/data.js